module.exports = __webpack_public_path__ + "static/Noemie_Malaize-b9fea0e710434797c1dba757c75816bd.png";